import { render, staticRenderFns } from "./FechamentoView.vue?vue&type=template&id=3a0a41a6"
import script from "./FechamentoView.vue?vue&type=script&lang=js"
export * from "./FechamentoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports